<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" md="12" sm="12">
        <v-banner icon="done_outline">
          Payment Success
          <template v-slot:actions>
            <v-btn color="blue darken-2" class="mb-4" outlined exact :to="{name:'Home'}">
              <v-icon class="mr-2">home</v-icon>Home
            </v-btn>
          </template>
        </v-banner>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" md="12" sm="12">
        <v-card outlined>
          <v-card-title class="justify-center">Thank You!</v-card-title>
          <v-card-title class="justify-center">
            <v-alert type="success">Your Payment has been successful</v-alert>
          </v-card-title>
          <v-card-text>
            <span class="subtitle font-weight-medium">Order Ref : {{tdId}}</span>
            <br />
            <span class="subtitle font-weight-medium">Payment Ref : {{paymentRef}}</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "PaymentSuccess",
  data: () => {
    return {};
  },
  computed: {
    tdId() {
      return this.$route.params.td_id;
    },
    paymentRef() {
      return this.$route.params.payment_ref;
    }
  }
};
</script>